const PlanAnimationService = {
    getData(steps, status, extraSteps, ignoreTeethForFiling) {

        const animationStatus = JSON.parse(JSON.stringify(status));
        const animationSteps = JSON.parse(JSON.stringify(steps));


        const extractionStep = this.getExtraStep(extraSteps, "5000");
        if (extractionStep) {
            this.updateStatus(animationStatus, extractionStep.toothIds, 16);
            animationSteps.unshift(this.convertExtraStep(extractionStep, 33));
        }

        const inlayStep = this.getExtraStep(extraSteps, "5021");
        if (inlayStep) {
            this.updateStatus(animationStatus, inlayStep.toothIds, 28);
            animationSteps.push(this.convertExtraStep(inlayStep, 18, app.$t('extra_treatments.inlay')));
        }

        const filling1Step = this.getExtraStep(extraSteps, "5001");
        if (filling1Step) {
            this.updateStatus(animationStatus, filling1Step.toothIds, 3);
            animationSteps.push(this.convertExtraStep(filling1Step, 27, app.$t('extra_treatments.filling')));
        }

        const filling2Step = this.getExtraStep(extraSteps, "5002");
        if (filling2Step) {
            this.updateStatus(animationStatus, filling2Step.toothIds, 3);
            animationSteps.push(this.convertExtraStep(filling2Step, 27, app.$t('extra_treatments.filling')));
        }

        const filling3Step = this.getExtraStep(extraSteps, "5003");
        if (filling3Step) {
            this.updateStatus(animationStatus, filling3Step.toothIds, 3);
            animationSteps.push(this.convertExtraStep(filling3Step, 27, app.$t('extra_treatments.filling')));
        }


        animationSteps.push({
            "state_id": 99,
            "state_pid": 99,
            "tooth_id": 0,
            "title": app.$t('plan_simple.end_of_treatment'),
            "animate": 1,
        });

        animationSteps.forEach((step)=>{
            if (parseInt(step.state_id)===19) {
                if (typeof ignoreTeethForFiling === 'undefined' || !ignoreTeethForFiling) step.tooth_id = this.getTeethForFiling(status, step.jaw);
            }
            if (typeof step.animation_pid !== "undefined") {
                step.state_id = step.animation_pid;
                step.state_pid = step.animation_pid;
            }
        });

        console.log('animationSteps', extractionStep, animationSteps);

        return ({
            autostart: true,
            language: app.$store.state.language,
            status: this.extendStatus(animationStatus),
            steps: this.setAnimationTitles(this.orderSteps(animationSteps)).filter((s) => (s.animate !== 0 && (s.state_pid === 99 || (s.tooth_id !== '' && parseInt(s.tooth_id) !== 0)))),
        });
    },

    getExtraStep(extraSteps, stateId) {
        if(extraSteps === null) return null;
        return extraSteps.find((step) => step.state_id === stateId && step.amount > 0 && step.toothIds && step.toothIds.length > 0);
    },

    convertExtraStep(step, targetStateId, title = "") {
        return ({
            "state_id": targetStateId,
            "state_pid": targetStateId,
            "tooth_id": step.toothIds.join(','),
            "title": title || step.title,
            "animate": 1,
        });
    },

    updateStatus(animationStatus, toothId, targetStatus) {
        toothId.forEach(tId => {
            const state = animationStatus.find(el => el.toothId === tId);
            if (!state) {
                animationStatus.push({
                    state_id: targetStatus,
                    state_pid: targetStatus,
                    tooth_id: tId,
                });
            }
        });

        console.log('animationStatus', animationStatus);
    },

    setAnimationTitles(steps) {
        steps.forEach((step) => {
            if (!step.fullJaw && [9, 11, 12, 13, 26, 199].includes(step.state_pid)) {
                //step.title_animation = app.$t('protocol_steps.animation_title_' + step.state_pid + (step.amount > 1 ? '_multiple' : '_single'));
                step.title_animation = app.$t('protocol_steps.animation_title_' + step.state_pid + '_single');
            } else {
                step.title_animation = app.$t(step.title_animation);
            }
        });
        return steps;
    },

    extendStatus(status, steps) {
        // nézni van-e a 6-oson kezelés, ha van akkor nincs 7-es, ha nincs, akkor lesz 6os is 7es is
        // tooth_idm, state_id, state_pid
        const statusMap = new Map();
        status.forEach((item) => {
            statusMap.set(item.tooth_id, item);
        });

        [17, 27, 37, 47].forEach((tId)=>{
            if (!statusMap.get(tId - 1) && !statusMap.get(tId)) statusMap.set(tId, {tooth_id: tId, state_id: 1, state_pid: 1});
        });

        const upper = [16, 15, 14, 13, 12, 11, 21, 22, 23, 24, 25, 26];
        const lower = [36, 35, 34, 33, 32, 31, 41, 42, 43, 44, 45, 46];

        upper.forEach((tId) => {
            if (!statusMap.get(tId)) statusMap.set(tId, {tooth_id: tId, state_id: 1, state_pid: 1});
        });

        lower.forEach((tId) => {
            if (!statusMap.get(tId)) statusMap.set(tId, {tooth_id: tId, state_id: 1, state_pid: 1});
        });

        return Array.from(statusMap.values());
    },

    getFirstTreatedJaws(steps) {
        // Map treated jaws by ordering
        const orderings = {};
        steps.forEach(step => {
            if(typeof step.ordering === "undefined") return;
            const ordering = String(step.ordering);
            if (typeof orderings[ordering] === "undefined") orderings[ordering] = [];
            orderings[ordering].push(step.jaw);
        });

        // Set treated jaws by ordering
        const firstTreatedJaws = {};
        let prevJaw = "";
        Object.keys(orderings).forEach((key) => {
            const ordering = orderings[key];
            if (prevJaw === "") {
                firstTreatedJaws[key] = ordering[0];
                prevJaw = ordering[ordering.length - 1];
            }
            else if (ordering.length === 1) {
                firstTreatedJaws[key] = ordering[0];
                prevJaw = ordering[0];
            }
            else if (ordering.length > 1) {
                firstTreatedJaws[key] = prevJaw;
                prevJaw = prevJaw === "upper" ? "lower" : "upper";
            }
        });
        return firstTreatedJaws;
    },

    orderSteps(steps) {
        try {
            const firstTreatedJaws = this.getFirstTreatedJaws(steps);

            steps.forEach((step) => {
                if (step.jaw === firstTreatedJaws[String(step.ordering)]) step.ordering -= 0.5;
            });
        } catch (error) {
            captureException(error);
        }

        steps.sort((a, b) => (a.ordering > b.ordering) ? 1 : ((b.ordering > a.ordering) ? -1 : 0));

        steps.forEach((step, i) => {
            step.ordering = i;
        });

        return steps;
    },

    getTeethForFiling(status, jaw) {
        let ids = [];
        status.forEach((tooth) => {
            if (parseInt(tooth.state_id) === 16) ids.push(parseInt(tooth.tooth_id));
        });
        ids = Helper.sortToothNumbers(ids).filter((id)=>{
            return ((jaw === "upper" && id < 30) || (jaw === "lower" && id > 30));
        });
        return ids.join(",");
    },
};
export default PlanAnimationService;
